import * as React from "react";
import { Select } from "antd";
import {
  defaultSelectFilterOption,
  defaultSelectFilterSort,
} from "../../../util/utils";
import {
  BoldOutlined,
  ItalicOutlined,
  UnderlineOutlined,
} from "@ant-design/icons";
import { TimberFonts } from "../../../util/fonts";
import { useState } from "react";
import { BrandFontDto } from "../../../generated/dashboard-client";
import { Button } from "./Button";

const { Option } = Select;

interface FontSelectProps {
  onChange: (font: BrandFontDto) => void;
  nameDefaultValue: string;
  sizeDefaultValue: number;
  boldDefaultValue: boolean;
  italicDefaultValue: boolean;
  underlineDefaultValue: boolean;
}

export default function FontSelect({
  onChange,
  nameDefaultValue,
  sizeDefaultValue,
  boldDefaultValue,
  italicDefaultValue,
  underlineDefaultValue,
}: FontSelectProps) {
  const [name, setName] = useState(nameDefaultValue);
  const [size, setSize] = useState(sizeDefaultValue);
  const [bold, setBold] = useState(boldDefaultValue);
  const [italic, setItalic] = useState(italicDefaultValue);
  const [underline, setUnderline] = useState(underlineDefaultValue);

  function onChangeName(name: string) {
    onChange({ name, size, bold, italic, underline });
    setName(name);
  }

  function onChangeSize(size: number) {
    onChange({ name, size, bold, italic, underline });
    setSize(size);
  }

  function onChangeBold() {
    onChange({ name, size, bold: !bold, italic, underline });
    setBold(!bold);
  }

  function onChangeItalic() {
    onChange({ name, size, bold, italic: !italic, underline });
    setItalic(!italic);
  }

  function onChangeUnderline() {
    onChange({ name, size, bold, italic, underline: !underline });
    setUnderline(!underline);
  }

  return (
    <div className={"set-font"}>
      <Select
        size={"large"}
        onChange={onChangeName}
        key={nameDefaultValue}
        defaultValue={nameDefaultValue}
        className={"font-family-dropdown"}
        showSearch
        optionFilterProp="children"
        filterOption={defaultSelectFilterOption}
        filterSort={defaultSelectFilterSort}
      >
        <Option value={""} disabled={true}>
          Select Font
        </Option>
        {TimberFonts.map((it) => (
          <Option
            key={it.name}
            value={it.name}
            className={it.class}
            style={{ fontFamily: it.name }}
          >
            {it.label}
          </Option>
        ))}
      </Select>
      <Select
        size={"large"}
        onChange={onChangeSize}
        key={sizeDefaultValue}
        defaultValue={sizeDefaultValue}
        className={"font-size"}
        optionFilterProp="children"
        filterOption={defaultSelectFilterOption}
        filterSort={defaultSelectFilterSort}
      >
        <Option value={""} disabled={true}>
          Select Size
        </Option>
        <Option key={"10"} value={"10"}>
          10
        </Option>
        <Option key={"20"} value={"20"}>
          20
        </Option>
        <Option key={"30"} value={"30"}>
          30
        </Option>
        <Option key={"40"} value={"40"}>
          40
        </Option>
      </Select>
      <div className={"font-styles"}>
        <Button
          type={"LinkPrimary"}
          onClick={onChangeBold}
          className={bold ? "on" : "off"}
        >
          <BoldOutlined />
        </Button>
        <Button
          type={"LinkPrimary"}
          onClick={onChangeItalic}
          className={italic ? "on" : "off"}
        >
          <ItalicOutlined />
        </Button>
        <Button
          type={"LinkPrimary"}
          onClick={onChangeUnderline}
          className={underline ? "on" : "off"}
        >
          <UnderlineOutlined />
        </Button>
      </div>
    </div>
  );
}
